<template>
  <div class="ctrl-login">
    <div class="ctrl wrap1100 space-100">
    <CtrlChangePassword />
    </div>



  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlChangePassword from "@/components/Ctrl/ChangePassword.vue";
export default {
  name: 'ctrl-login',
  components: {
    CtrlChangePassword,
  },
data() {
    return {};
  },
  computed: {
  ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>

</style>
